module.exports = __webpack_public_path__ + "static/media/close.7082e21a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ConditionsModal/close.svg
// module id = 309
// module chunks = 0